import React, {Component} from 'react'
import Dropdown from 'react-dropdown'
import Texts from './texts'
import browserLang from './takeLang'

const options = [
  {value: 'ru', label: 'Русский'},
  {value: 'en', label: 'English'},
  {value: 'cn', label: '中文'}
]


const defaultOption = options.find( opt => opt.value === browserLang ) || options[ 1 ]

export default class Lang extends Component {

  constructor() {
    super()

    let texts = this.getTexts(defaultOption.value)
    this.state = {
      val: defaultOption,
      texts
    }

  }




  componentWillMount() {
    setTimeout(() => {
      this.props.onLangChange(this.state.val.value, this.state.texts)
    }, 1000);
    this.props.onLangChange(this.state.val.value, this.state.texts)
  }


  onSelect(val) {
    /*
    if (val.value==="ru"){
      location="http://addreality.ru/signup";
    }

    if (val.value==="en"){
      location="https://addreality.com/signup";
    }
    */

    let texts = this.getTexts(val.value)

    this.setState( {
      val,
      texts
    } )


    this.props.onLangChange(val.value, texts)

  }


  getTexts( lang ) {
    let texts = {}
    for (let txt in Texts) {
      if (Texts.hasOwnProperty(txt)) {
        texts[txt] = Texts[txt][lang]
      }
    }
    return texts
  }


  render() {
		return (
      <div className="langSelect">
        <label>{this.state.texts.lang}</label>
        <Dropdown options={options} onChange={val => {this.onSelect(val)}} value={this.state.val} placeholder="Select an option" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/lang/lang.jsx